import { render, staticRenderFns } from "./Release_share.vue?vue&type=template&id=bc018a04&scoped=true&"
import script from "./Release_share.vue?vue&type=script&lang=js&"
export * from "./Release_share.vue?vue&type=script&lang=js&"
import style0 from "./Release_share.vue?vue&type=style&index=0&id=bc018a04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc018a04",
  null
  
)

export default component.exports